import React from "react";
import CTAButton from "../CTAButton/CTAButton";
import "./Analytics.css";
import { Link } from "react-router-dom";
import EmailMarketingAnalytics from "../../assets/EmailMarketingAnalytics.png";
import trackemailperfomance from "../../assets/trackemailperfomance.png";
import EmailReportsandCampaignAnalytics from "../../assets/EmailReportsandCampaignAnalytics.jfif";
import SubscriberAnalytics from "../../assets/SubscriberAnalytics.png";
import aiFallback from "../../assets/ai-section-fallback.png";
import pricebannerana from "../../assets/new/review.png";




const Analytics = () => {
  return (
    <div className="analytics-page">
      {/* HERO SECTION */}
      <section className="analytics-hero">
        <div className="hero-left">
          <Link to="/features" className="back-link">← Back to features</Link>
          <h1>Email Marketing Analytics That Drive Better Decisions</h1>
          <p>
            Understand the impact of every email campaign with powerful email marketing analytics. <Link className="linkcolor" to="/email-marketing-platform">MailSnappy</Link> gives you real time insights into email performance, helping you monitor opens, clicks, conversions, and subscriber engagement from one intuitive dashboard. With accurate campaign data and actionable reports, you can optimize every email, improve customer engagement, and make smarter marketing decisions that support long term business growth.
          </p>
          <div className="hero-form"><CTAButton>Get started</CTAButton></div>
        </div>
        <div className="hero-right">
          <img src={EmailMarketingAnalytics} alt="Email marketing analytics dashboard preview" width="640" height="420" />
        </div>
      </section>

      {/* DISCOVER WHAT SUBSCRIBERS LOVE */}
      <section className="analytics-section">
        <div className="section-left">
          <img src={trackemailperfomance} alt="Email performance tracking dashboard" width="640" height="420" loading="lazy" />
        </div>
        <div className="section-right">
          <h2>Track Email Performance and Subscriber Engagement</h2>
          <p>
            Discover what resonates with your audience by tracking email opens, click through rates, and subscriber engagement. Gain valuable insights into campaign performance to identify successful strategies, improve future email campaigns, and deliver more relevant content that keeps subscribers engaged and encourages higher conversions.
          </p>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="testimonial">
        <div className="testimonial-container">
          <div className="testimonial-text">
            <p>
              “Since joining Mailsnappy, our average email open rate has increased 
              from 16% to 34% — all thanks to real-time analytics.”
            </p>
            <p className="author">– Annie Goodfirth, Inkrix</p>
          </div>
          <img src={pricebannerana} alt="Analytics customer testimonial avatar" className="testimonial-img" width="96" height="96" loading="lazy" />
        </div>
      </section>

      {/* ACTIONABLE DATA */}
      <section className="analytics-section reverse">
        <div className="section-left">
             <img src={EmailReportsandCampaignAnalytics} alt="Email reports and campaign analytics dashboard" width="640" height="420" loading="lazy" />
        </div>
        <div className="section-right">
          <h2>Email Reports and Campaign Analytics at a Glance</h2>
          <p>
            Monitor your email marketing performance with easy to understand reports, visual dashboards, and campaign analytics. View key metrics including email opens, link clicks, conversions, and subscriber activity in one place, making it easier to evaluate campaign success and improve your marketing strategy with confidence.
          </p>
        </div>
      </section>

      {/* MORE DETAIL SECTION */}
      <section className="analytics-section">
        <div className="section-left">
          <h2>Subscriber Analytics for Smarter Email Marketing</h2>
          <p>
            Understand how every subscriber interacts with your email campaigns through detailed subscriber analytics and activity tracking. Identify your most engaged contacts, analyze customer behavior, and use data driven insights to personalize future campaigns, strengthen customer relationships, and maximize email marketing performance.
          </p>
        </div>
        <div className="section-right">
          <img src={SubscriberAnalytics} alt="Subscriber analytics dashboard preview" width="640" height="420" loading="lazy" />
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta-section">
        <h2>Start for free today</h2>
        <p>
          Sign up and send your first campaign in minutes. No credit card required.
        </p>
        <CTAButton className="primary-btn">Get started</CTAButton>
      </section>
    </div>
  );
};

export default Analytics;
